import Vue from 'vue'
import Vuex from 'vuex'
import { PageBuilder } from '../Builder/PageBuilder'
import { LayoutBuilder } from '../Builder/LayoutBuilder'
import ActionsModule from './modules/ActionsModule'
import ColumnModule from './modules/ColumnModule'
import ComponentModule from './modules/ComponentModule'
import ComponentColumnModule from './modules/ComponentColumnModule'
import ComponentComponentModule from './modules/ComponentComponentModule'
import ComponentRowModule from './modules/ComponentRowModule'
import ComponentSectionModule from './modules/ComponentSectionModule'
import HeaderModule from './modules/HeaderModule'
import TopSectionModule from './modules/TopSectionModule'
import BottomSectionModule from './modules/BottomSectionModule'
import LayoutRowModule from './modules/LayoutRowModule'
import LayoutPageComponentModule from './modules/LayoutPageComponentModule'
import LayoutComponentModule from './modules/LayoutComponentModule'
import LayoutColumnModule from './modules/LayoutColumnModule'
import LayoutModule from './modules/LayoutModule'
import EventModule from './modules/EventModule'
import PageModule from './modules/PageModule'
import PageComponentModule from './modules/PageComponentModule'
import RowModule from './modules/RowModule'
import SectionModule from './modules/SectionModule'
import SettingsModule from './modules/SettingsModule'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    toolbar: false,
    previewMode: false,
    elementToolbar: false,
    menu: 'elements',
    editingElement: null,
    parentModule: null,
    editingModule: null
  },
  mutations: {
    toggleElementToolbar(state, payload) {
      state.editingElement = payload.element
      state.editingModule = payload.module
      state.elementToolbar = payload.open
      state.parentModule = payload.parentModule
    },
    togglePreviewMode(state) {
      state.previewMode = ! state.previewMode
    },
    export(state, payload) {
      if (payload.layout) {
        return (new LayoutBuilder(state.layoutModule)).build()
      }
      (new PageBuilder(state.pageModule.page)).build()
    },
    updateToolbar(state, payload) {
      state.toolbar = payload
    },
    updateMenu(state, payload) {
      state.menu = payload
    }
  },
  modules: {
    actionsModule: ActionsModule,
    columnModule: ColumnModule,
    componentModule: ComponentModule,
    componentColumnModule: ComponentColumnModule,
    componentComponentModule: ComponentComponentModule,
    componentRowModule: ComponentRowModule,
    componentSectionModule: ComponentSectionModule,
    eventModule: EventModule,
    headerModule: HeaderModule,
    bottomSectionModule: BottomSectionModule,
    topSectionModule: TopSectionModule,
    layoutModule: LayoutModule,
    layoutRowModule: LayoutRowModule,
    layoutColumnModule: LayoutColumnModule,
    layoutComponentModule: LayoutComponentModule,
    layoutPageComponentModule: LayoutPageComponentModule,
    pageModule: PageModule,
    pageComponentModule: PageComponentModule,
    rowModule: RowModule,
    sectionModule: SectionModule,
    settingsModule: SettingsModule,
    // paletteModule: PaletteModule,
    // assetModule: AssetModule,
    },
})
